module.exports = __webpack_public_path__ + "img/schedule-dash-open.0586e995.png";